import {get} from 'aws-amplify/api';
import {Command, type GetMethod} from '../../Command';
import type {PaginateDraftResponse} from '../../../dto/draft/PaginateDraftResponse';

export interface PaginateDraftInput {
  page?: number;
  offset?: number;
  /** Taille de page (défaut serveur : 1000, borné à 1000). */
  limit?: number;
}

export class PaginateDraftCommand extends Command<GetMethod, PaginateDraftResponse> {
  constructor({page, offset, limit}: PaginateDraftInput) {
    const queryParams: Record<string, string> = {};
    if (page !== undefined) {
      queryParams.page = page.toString();
    }
    if (offset !== undefined) {
      queryParams.offset = offset.toString();
    }
    if (limit !== undefined) {
      queryParams.limit = limit.toString();
    }
    super(get, {
      path: `/draft/list`,
      options: {
        queryParams,
      },
    });
  }

  async deserialize(output: ReturnType<typeof get>): Promise<PaginateDraftResponse> {
    const {body} = await output.response;
    return await (body.json() as unknown as Promise<PaginateDraftResponse>);
  }
}
